import type { DependencyList } from 'react';
import { useCallback, useLayoutEffect, useRef } from 'react';

export function useCallbackIfMounted<TArgs extends readonly unknown[], TReturn>(
  callback: (...args: TArgs) => TReturn,
  deps: DependencyList = [],
): (...args: TArgs) => TReturn | undefined {
  const isMounted = useRef(false);

  useLayoutEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback((...params: TArgs) => {
    if (isMounted.current) {
      return callback(...params);
    }
    return undefined;
  }, deps);
}
